import { db } from '../firestore';
import { currentTenant } from '../stores/tenant';
import { currentProduct } from '../stores/product';
import { getBuyerPersona, getFeatureGroups } from './PostHelper';

function get__store(store) {
    let $val
    store.subscribe($ => $val = $)()
    return $val
}




export async function getProductData(id) {
    if (id == null)
        id = get__store(currentProduct).uid;
    return new Promise((resolve, reject) => {
        var docRef = db.collection("tenants").doc(get__store(currentTenant).tid).collection('products').doc(id);

        docRef.get().then(function (doc) {
            if (doc.exists) {
                let data = doc.data();
                data['id'] = doc.id;
                resolve(data);
            } else {
                reject("No such document!");
            }
        }).catch(function (error) {
            reject("Error getting document:", error);

        });
    });

}

export async function getBenefits(productId, buyerPersonaId) {
    if (productId == null)
        return;

    return new Promise(async (resolve, reject) => {
        let querySnapshot = await db.collection("tenants").doc(get__store(currentTenant).tid).collection('products').doc(productId).collection('buyerPersona').doc(buyerPersonaId).collection('benefits').get();
        let rVal = {
            model: [],
            staticData: {
                buyerPersona: null,
                featureGroups: null,
                document: null
            }
        };
        querySnapshot.forEach(function (doc) {
            rVal.model.push({ id: doc.id, data: doc.data() });
        });

        rVal.staticData.buyerPersona = await getBuyerPersona(productId, buyerPersonaId);
        rVal.staticData.featureGroups = await getFeatureGroups(productId);
        rVal.staticData.document = await getProductData(productId);

        resolve(rVal);
    });

}

export async function getBuyerPersonas(productId) {
    if (productId == null)
    return;

return new Promise(async (resolve, reject) => {
    let querySnapshot = await db.collection("tenants").doc(get__store(currentTenant).tid).collection('products').doc(productId).collection('buyerPersona').get();
    let rVal = [];
    querySnapshot.forEach(function (doc) {
        rVal.push({ id: doc.id, data: doc.data() });
    });
    resolve(rVal);
});
}

export async function getWebsites(id) {
    if (id == null)
        id = get__store(currentProduct).uid;
    return new Promise(async (resolve, reject) => {
        let querySnapshot = await db.collection("tenants").doc(get__store(currentTenant).tid).collection('products').doc(id).collection('websites').get();
        let rVal = [];
        querySnapshot.forEach(function (doc) {
            rVal.push({ id: doc.id, data: doc.data() });
        });
        resolve(rVal);
    });

}

export async function getWebsite(productId, id) {
    console.log(productId);
    console.log(id);

    return new Promise(async (resolve, reject) => {
        let docRef = await db.collection("tenants").doc(get__store(currentTenant).tid).collection('products').doc(productId).collection('websites').doc(id).get();
        resolve({ id: docRef.id, data: docRef.data() });
    });

}
